import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleclear"];

  clear() {
    this.toggleclearTargets.forEach((target) => {
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        target.value = "";
      } else if (target.tagName === "SELECT") {
        target.selectedIndex = 0;
      }
    });
  }
}
